import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {ssoAccountsStateSelector} from './sso-accounts-state.slice';

import type {SsoAccountsFilters, SsoAccountsSearch} from '../models/typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {DraftSortField} from 'src/openapi/admin/models/DraftSortField';
import type {SsoDraft} from 'src/openapi/admin/models/SsoDraft';

export const ssoAccountsSlice = getCachedTableDataSlice<
    SsoDraft[],
    SsoAccountsSearch,
    DraftSortField,
    SsoAccountsFilters
>('ssoAccounts');

export const ssoAccountsActions = ssoAccountsSlice.actions;
const ssoAccountsCacheSelector: CachedTableCacheSelector<SsoDraft[]>
    = state => state.ssoAccounts.result.cache;
export const ssoAccountsDataSelector: CachedTableDataSelector<SsoDraft[]>
    = state => state.ssoAccounts.result;
export const ssoAccountsResultSelector = getCachedTableResultSelector(
    ssoAccountsCacheSelector,
    ssoAccountsStateSelector,
);
